import * as z from "zod";

// acknowledged=false clears the recorded consent (revoke).
export const setOfferNetworkDataSharingConsent = {
  name: "setOfferNetworkDataSharingConsent" as const,
  input: z.object({ acknowledged: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
